import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';

@Component({
    components: AllComponents(),
})
export default class PlanDelete extends Mixins(CommonView) {
    public mode: number = 0;
    public error: string = "";

    public slug: string = "";
    public planId: string = "";

    public userPlan: SBAPI.UserPlan = {
        count: 1,
        plan: SBAPI.plan(),
    }

    public async created() {
        this.slug = this.$route.params.slug;
        this.planId = this.$route.params.planId;

        let response = await SBAPI.PlanController.getPlanUsingGET(Number(this.planId)).catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return;
        }
        this.userPlan.plan = response.data;
    }
    public async nextMode(index: number, userPlan: SBAPI.UserPlan) {
        let response = await SBAPI.ArtistController.getArtistUsingGET(this.slug).catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return;
        }

        if (response.data.planList && response.data.planList.length > 1) {//プランが1つだけならmodeを進めずに即削除
            this.mode = 1;
        } else {
            this.deletePlan()
        }
    }

    public async deletePlan() {
        let response = await SBAPI.UserPlanController.deleteUserPlanUsingDELETE(this.userPlan.plan.id!).catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return;
        }
        this.mode = 2;
    }

}
